import { Helpers } from '../../helpers';
import { IFunction } from '../../interfaces/ifunction';
import { BudgetCategory } from '../budget-category';
import { Project } from '../project';
import { ProjectTemplate } from '../project-template';

export class FunctionBase {
  FunctionId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  BudgetCategories_Function?: Array<BudgetCategory> | null;
  Projects_Function?: Array<Project> | null;
  ProjectTemplates_Function?: Array<ProjectTemplate> | null;

  constructor(item?: IFunction) {
    if (item) {

      this.FunctionId = item.FunctionId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.BudgetCategories_Function = Helpers.createClassArray(BudgetCategory, item.BudgetCategories_Function);
      this.Projects_Function = Helpers.createClassArray(Project, item.Projects_Function);
      this.ProjectTemplates_Function = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_Function);
    }
  }
}